export const INIT_SESSION = 'app/App/session/INIT_SESSION';
export const DESTROY_SESSION = 'app/App/session/DESTROY_SESSION';
export const SELECT_PROPERTY = 'app/App/session/SELECT_PROPERTY';
export const RESET_APP = 'app/App/session/RESET_APP';
export const CHANGE_LOCALE = 'app/App/session/CHANGE_LOCALE';
export const SET_PREFERENCES = 'app/App/session/SET_PREFERENCES';
export const SET_CONFIG = 'app/App/session/SET_CONFIG';
export const SET_AUTHORISED_PROPERTIES = 'app/App/session/SET_AUTHORISED_PROPERTIES';
export const SET_PROPERTY_EXTRA_INFO = 'app/App/session/SET_PROPERTY_EXTRA_INFO';

/**
 * List & definitions of all preferences in the app
 * @type {Object}
 * @property {*} defaultValue - the default value to be used if a preference is undefined
 * @property {String} type - type of preference. Only supported for now: boolean
 */
export const PREFERENCES_DEFINITIONS = {
    'views.sellingRateCalendarPage.inventoryGrouping': {
        defaultValue: 'category',
        type: 'string',
    },
};
